import BaseProxy from '@/proxies/Proxy';

class AuthProxy extends BaseProxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('auth', parameters);
  }

  /**
   * Method used to login.
   *
   * @param {String} username The username.
   * @param {String} password The password.
   * @param {String} two_fa_code The password.
   *
   *
   * @returns {Promise} The result in a promise.
   */
  login({ username, password, two_fa_code }) {
    const data = {
      username,
      password,
      two_fa_code,
      // client_id: process.env.API_CLIENT_ID,
      // client_secret: process.env.API_CLIENT_SECRET,
      // grant_type: 'password',
      // scope: '',
    };

    return this.submit('post', `${this.endpoint}/login`, data);
  }

  logout() {
    return this.submit('post', `${this.endpoint}/logout`);
  }

  /**
   * Method used to register the user.
   *
   * @param {Object} data The register data.
   *
   * @returns {Promise} The result in a promise.
   */
  register(data) {
    return this.submit('post', `${this.endpoint}/register`, data);
  }
}

export default AuthProxy;



// WEBPACK FOOTER //
// ./src/proxies/AuthProxy.js